import config from "config/config";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { useAxios } from "hooks/useAxios/useAxios";
import { VIEW_CLAIM_STATUS_GTM, VIEW_CLAIM_STATUS_MP } from "modules/common/trackingConsts";
import { getPageUrl } from "utils/getPageUrl";
import { NavButton } from "./NavButton";

const WEBAPP_SIGNED_IN_ENDPOINT = `${config.webappUrl}/api/users/check_signed_in`;

export const CheckCompensationButton = () => {
  const language = useLanguage();
  const translations = useTranslations();

  const { data } = useAxios<{
    signed_in: string;
  }>({
    url: WEBAPP_SIGNED_IN_ENDPOINT,
    withCredentials: true,
  });

  const navButtonHref = data?.signed_in
    ? `${config.webappUrl}/claims-and-flights`
    : getPageUrl(language, "webappNewClaim");

  const navButtonTitle = data?.signed_in ? translations("view_claim_status") : translations("check_compensation");

  return (
    <NavButton
      href={navButtonHref}
      title={navButtonTitle}
      trackingEvents={{ gtmEvent: VIEW_CLAIM_STATUS_GTM, mixpanelEvent: VIEW_CLAIM_STATUS_MP }}
      dataTestId="top-navbar-view-status-button"
    />
  );
};
